module.exports = __webpack_public_path__ + "img/hypermeteo-marchio.202dcbe2.png";